export default __webpack_public_path__ + "static/sprite-c09ce95dd6451597defa620f5edbc725.svg";